module.exports = __webpack_public_path__ + "static/media/Accountability.47a03654.jpg";